import React, { useEffect, useState, useReducer } from 'react';
import {Folha, Dinheiro} from '..'
import {usePedido} from '../../services/usePedidos';
import { Row, Col, Button, Divider, Tag, Dropdown, Menu, Drawer, message, notification} from 'antd';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faCheck, faPlus, faPrint, faBoxFull, faUndo, faFileInvoice, faFileAlt} from '@fortawesome/pro-duotone-svg-icons';
// import {AutoCompletePessoasWidget, SelectLoggedInUser} from '@contentsys/contentsys-react-components';
import {Itens} from './Itens';
import {Servicos} from './Servicos';
import {StatusEstoque} from './StatusEstoque';
import {StatusPedido} from './StatusPedido';
import {StatusNFe} from './StatusNFe';
import {useAxios} from '../../hooks';
//import {reducerPedido, defaultState, reducerPedidoTypes} from '../../../store/reducer-pedido';
import { ImpressaoPedido } from './ImpressaoPedido';
import { ImpressaoRomaneio } from './ImpressaoRomaneio';
import { useSelector, useDispatch} from 'react-redux';
import './form-pedido.scss';
import {PedidoDescricoes} from '../Formulario-pedido-descricoes/PedidoDescricoes'
import { AutoCompletePessoasWidget } from '../pessoas/busca/auto-complete-pessoas-widget';

let html2Pdf;
import('html2pdf.js').then(result => {
    html2Pdf = result;
})



const NumeroPedido = ({pedido}) => {

    if(pedido && pedido.numeroPedido){
        return (<Tag >{pedido.numeroPedido}</Tag>)
    }
    return <></>;
}

const AcoesFormulario = ({titulo='Pedido',/* pedido *//*,  dispatch */ tamBotao}) => {
    // estados e hooks devem ser declarados sempre (não-condicionalmente)
    const [abrindo, setAbrindo] = useState(false);
    const {emitirNFe, atualizaPedido, separarEstoque, voltarEstoque} = usePedido();
    const [imprimindo, setImprimindo] = useState(false);
    const [tipoImpressao, setTipoImpressao] = useState('pedido');

    const reducerPedido = useSelector((state) => state.reducerPedido);
    const reducerTermosUso = useSelector((state) => state.reducerTermosUso);

    const pedido = reducerPedido.pedido;
    const {termosUso} = reducerTermosUso;
    const dispatch = useDispatch();

    const abrirPedido = async () => {
        setAbrindo(true);
        const novoPedido = await atualizaPedido(Object.assign(pedido, {
            status: "ABERTO"
        }));
        setAbrindo(false);
        dispatch({type: reducerPedido.reducerPedidoTypes.SET_PEDIDO, payload: novoPedido});

    }

    const onReadyToPrint = async () => {
        const copyStyles = async (src, dest) => {
            const styleSheetsArr = Array.from(src.styleSheets);
            for(const styleSheet of styleSheetsArr){

                if(styleSheet.href){
                    const rules = styleSheet.cssRules;
                    let text = "";
                    for(const rule of rules ){
                        text += rule.cssText + "\n";
                    }

                    const styleElm = dest.createElement("style");
                    styleElm.innerHTML = text;
                    dest.head.appendChild(styleElm)
                } else {
                    dest.head.appendChild(styleSheet.ownerNode.cloneNode(true))
                }

            }
            Array.from(src.fonts).forEach(font => dest.fonts.add(font))
        }

        const printElement = document.getElementById("print");
        if (!printElement) {
            console.error("Elemento #print não encontrado");
            return;
        }

        const winPrint = window.open("", "Impressao", "width=1000,height=600");
        winPrint.document.body.appendChild(printElement.cloneNode(true));

        await copyStyles(window.document, winPrint.document);

        winPrint.focus()
        winPrint.print()
        winPrint.close()
    }

    // Ao iniciar a impressão apenas marcamos o tipo e ativamos o componente de impressão.
    // O efeito abaixo aguardará até que o DOM de '#print' esteja populado e então chamará a rotina de impressão.
    const printHandle = (tipo = 'pedido') => {
        setTipoImpressao(tipo);
        setImprimindo(true);
    }

    React.useEffect(() => {
        if(!imprimindo) return;

        let cancelled = false;

        const waitForPrintContent = async () => {
            const start = Date.now();
            const timeout = 5000; // ms
            while(!cancelled){
                const el = document.getElementById('print');
                if(el && el.childNodes && el.childNodes.length > 0 && el.innerText.trim().length > 0){
                    break;
                }
                if(Date.now() - start > timeout){
                    console.warn('Timeout aguardando conteúdo de impressão (#print)');
                    break;
                }
                await new Promise(r => setTimeout(r, 50));
            }

            try{
                if(!cancelled){
                    await onReadyToPrint();
                }
            } catch(err){
                console.error('Erro durante impressão:', err);
            } finally {
                if(!cancelled){
                    setImprimindo(false);
                }
            }
        }

        waitForPrintContent();

        return () => { cancelled = true; }
    }, [imprimindo, tipoImpressao, pedido]);

    const separaEstoqueHandle = async () => {
        const novoPedido = await separarEstoque(pedido);
        dispatch({type: reducerPedido.reducerPedidoTypes.SET_PEDIDO, payload: novoPedido});
    }

    const voltarEstoqueHandle = async () => {
        const novoPedido = await voltarEstoque(pedido);
        dispatch({type: reducerPedido.reducerPedidoTypes.SET_PEDIDO, payload: novoPedido});
    }

    const emitirNFeHandle = async () => {
        const novoPedido = await emitirNFe(pedido);
        let url = "";
        if(process.env.REACT_APP_ENV == "dev"){
            url = "http://localhost:9001/#/emitir-nfe?id=" + novoPedido.idNFe;
        } else if(process.env.REACT_APP_ENV == "test"){
            url = "https://apptest.contentsys.com.br/#/emitir-nfe?id=" + novoPedido.idNFe;
        } else if(process.env.REACT_APP_ENV == "prod"){
            url = "https://nfe.contentsys.com.br/#/emitir-nfe?id=" + novoPedido.idNFe;
        }
        window.open(url, "_blank");
//                window.location = url;

    }

    const menuAcoes = (
        <Menu>
            <Menu.Item key="imprimirPedidoKey" onClick={() => printHandle('pedido')} icon={<FontAwesomeIcon icon={faPrint} />}>
                Imprimir Pedido
            </Menu.Item>
            
            {pedido.tipoPedido !== 'ORDEM_SERVICO' && pedido.itens?.length > 0 && (
                <Menu.Item key="imprimirRomaneioKey" onClick={() => printHandle('romaneio')} icon={<FontAwesomeIcon icon={faFileAlt} />}>
                    Imprimir Romaneio
                </Menu.Item>
            )}

            {(() => {
                if(pedido.estoque !== "SEPARADO"){
                    return <Menu.Item key="separarEstoqueKey" onClick={separaEstoqueHandle} icon={<FontAwesomeIcon icon={faBoxFull}></FontAwesomeIcon>}>Separar Estoque</Menu.Item>
                } else {
                    return <Menu.Item key="voltarEstoqueKey" onClick={voltarEstoqueHandle} icon={<FontAwesomeIcon icon={faUndo}></FontAwesomeIcon>}>Voltar Estoque</Menu.Item>
                }
            })()}
            {(()=> {
                if(pedido.possuiNFe == 0 && pedido.estoque == "SEPARADO" ){
                    return <Menu.Item key="emitirNFeKey" onClick={emitirNFeHandle} icon={<FontAwesomeIcon icon={faFileInvoice}></FontAwesomeIcon>}>Emitir NFe</Menu.Item>
                }
            })()}
        </Menu>
    );

    // render condicional — agora seguro pois os hooks já foram invocados acima
    if(pedido.status === "RASCUNHO"){
        return (
                <Col sm={24} xs={24} md={tamBotao} className="botaoAcao"> 
                    <Button type="primary" className="botao" size='large' loading={abrindo} onClick={abrirPedido} icon={<FontAwesomeIcon icon={faCheck}></FontAwesomeIcon>}>
                        Abrir {titulo}
                    </Button>
                </Col>
        );
    }

    return <><Col sm={24} xs={24} md={tamBotao} className="botaoAcao"> 
        <Dropdown placement="topRight" trigger={["click"]} overlay={menuAcoes}>
            <Button className="botao" size='large' type="primary" loading={imprimindo} icon={<FontAwesomeIcon icon={faPlus}></FontAwesomeIcon>}>Ações</Button>
        </Dropdown>
    </Col>
    
    {imprimindo && (
        <>
            {tipoImpressao === 'romaneio' ? (
                <ImpressaoRomaneio pedido={pedido} />
             ) : (
                <ImpressaoPedido pedido={pedido} />
             )}
        </>
    )}
    </> 
}
const FormularioPedido = (props) => {

    const {match: {params}} = props;
    const {titulo="Pedido"} = props;
    const {tipo} = props;
    const {getApiEmitirNotas} = useAxios();

    const {itensAdicionais=<></>, totaisAdicionais=()=>[], camposAdicionais=(pedido) => []} = props;

    const {novoPedido, vinculaCliente, vinculaVendedor, desvinculaCliente, desvinculaVendedor, atualizaPedido, buscaPedido, buscaTermosUso} = usePedido(tipo);
    // const [pedido, setPedido] = useState({});

    //const [state, dispatch] = useReducer(reducerPedido, defaultState);
    //const [stateServicos, dispatchServicos] = useReducer(reducerPedido, []);
    const [formObsVisible, setFormObsVisible] = useState(false);
    const reducerPedido = useSelector((state) => state.reducerPedido);
    const pedido = reducerPedido.pedido;
   
    const dispatch = useDispatch();
    
    //const {pedido} = state;


    useEffect(()=>{
        
        iniciaPedido();
    }, []);

    useEffect(() => {
        setFormObsVisible(false);
    }, [pedido])

    useEffect(() => {
        dadosIniciaisClienteEventEmitter.notifyAll(pedido.cliente);
    }, [pedido])

  

    const iniciaPedido = async () => {
        
        if(params.id){
            const pedidoBd = await buscaPedido(params.id);
            setTimeout(()=>{
                dispatch({type: "setPedido", payload: pedidoBd} );
            }, 100)
        } else {
            const p = await novoPedido();
            dispatch({type: "setPedido", payload: p} );
        }
        
    }

    const criaDadosIniciaisEventEmitter = (valorInicial) => {
        const observadores = [];

        const register = (func) => {
            observadores.push(func);
            
        }
        const notifyAll = (valor) => {
            observadores.forEach(observador => {
                observador(valor);
            })
        }

        return {register, notifyAll}
    }

    const dadosIniciaisClienteEventEmitter = criaDadosIniciaisEventEmitter();
    

    const aoSelecionarCliente = async (pessoa) => {
        const novaPedido= (pessoa && pessoa !== null)?  await vinculaCliente(pedido, pessoa) : await desvinculaCliente(pedido, pessoa);
        dispatch({type: "setPedido", payload: novaPedido} );        
    }

    const aoSelecionarVendedor = async (vendedor) => {     
        let novoPedido; 
        try{

            if(vendedor && vendedor !== null) {
                novoPedido = await vinculaVendedor(pedido, vendedor)
            } else { 
                novoPedido = await desvinculaVendedor(pedido, vendedor);
            }
            dispatch({type: "setPedido", payload: novoPedido} );

        } catch(err){
            const {response} = err;
            const {data} = response;
            let notificacao = {
                title: "Erro.",
                content: "Nao foi possivel alterar o vendedor."
            }
            if(data.err){
                notificacao.content += " " + data.err;
            }
            message.error(notificacao)
        }
    }

    const abrirEdicaoObs = () => {
        setFormObsVisible(true)
    }

    
    let tamBotao = 12;

    if(tipo == "ORDEM_SERVICO"){
        tamBotao=8
    }

    

    
    return <>
        <Folha>
                <Row key={1} style={{borderBottom: "solid 3px #1a4f81"}} justify="space-between">
                    <Col key={2} span={12}><h1 style={{textAlign:  "left"}}>{titulo} <NumeroPedido pedido={pedido}></NumeroPedido></h1> </Col>
                    <Col key={3} span={6} style={{textAlign: "right"}}>
                            <StatusNFe status={pedido.statusNFe}></StatusNFe> 
                            <StatusEstoque status={pedido.estoque}></StatusEstoque>
                    </Col>
                    <Col key={4} span={6}> 
                        <StatusPedido key="statysPedido" pedido={pedido} /* dispatch={dispatch} */ />
                    </Col>
                </Row>
                <Row style={{marginTop: "23px"}} gutter={16}>
                    <Col md={12} xs={24} sm={24} style={{textAlign: "left"}}>
                        {/* <AutoCompletePessoa 
                            aoSelecionarPessoa={aoSelecionarCliente}
                            tipo="CLIENTE"
                            label="Cliente"
                            name="cliente"
                            /* reducer={{state, dispatch}} */
                           /* permiteCadastro={true}

                        ></AutoCompletePessoa> */}
                        
                        <span>Cliente</span>
                        <AutoCompletePessoasWidget 
                            getApi={getApiEmitirNotas}                 
                            tipoPessoa="CLIENTE"
                            onChange={aoSelecionarCliente}
                            comBotaoAdicionar={true}
                           // onChangeEventEmitters={[dadosIniciaisClienteEventEmitter]}
                            onAfterSave={aoSelecionarCliente}
                            autoCompleteProps={{
                                style: {
                                    "width": "calc(100% - 40px)"
                                }
                            }}
                            value={pedido.cliente}
                            inputProps={{
                                size: 'large'
                                
                            }}
                        ></AutoCompletePessoasWidget>
                    </Col>
                    <Col md={12} xs={24} sm={24} style={{textAlign: "left"}}>

                        <span>Vendedor</span>
                        <AutoCompletePessoasWidget
                            getApi={getApiEmitirNotas}                 
                            tipoPessoa="VENDEDOR"
                            onChange={aoSelecionarVendedor}
                            comBotaoAdicionar={false}
                            value={pedido.vendedor}

                            autoCompleteProps={{
                                style: {
                                    "width": "calc(100% )"
                                }
                            }}
                            inputProps={{
                                size: 'large'
                                
                            }}
                        ></AutoCompletePessoasWidget>
                    </Col>

                </Row>

                {(()=> {
                    if(tipo == "ORDEM_SERVICO"){
                        return <PedidoDescricoes
                                    label='Descrição'
                                    campo="descricao"
                                    pedido={pedido}>    
                                </PedidoDescricoes>
                    }
                })()}

                <Divider orientation="left">Produtos</Divider>

                <Itens /* reducer={{state, dispatch}} *//>

                {(()=> {
                    if(tipo == "ORDEM_SERVICO"){
                        return <>
                                <Divider orientation="left">Serviços</Divider>
                                <Servicos /* reducer={{stateServicos, dispatchServicos}} *//>
                            </>
                    }
                })()}
                

               <PedidoDescricoes
                    label='Observação'
                    campo="obs"
                    pedido={pedido} 
                >
                </PedidoDescricoes>

            
                

                


                <Row className="bottom-toolbox" >
                    <Col sm={8} xs={8} md={4} className="total bg-light blue-border" >
                        <p className="label">Produtos</p>
                        <p className="valor"><Dinheiro value={pedido.totalProdutos}></Dinheiro></p>
                    </Col>

                    {(()=> {
                        if(tipo == "ORDEM_SERVICO"){
                            return <Col sm={8} xs={8} md={4} className="total bg-light red" >
                                        <p className="label">Serviços</p>
                                        <p className="valor"><Dinheiro value={pedido.totalServicos}></Dinheiro></p>
                                    </Col>
                        }
                    })()}

                    
                    
                    <Col sm={8} xs={8} md={4} className="total bg-light red" >
                        <p className="label">Descontos</p>
                        <p className="valor"><Dinheiro value={pedido.totalDescontos}></Dinheiro></p>
                    </Col>
                    <Col sm={8} xs={8} md={4} className="total bg-light green" >
                        <p className="label">Total</p>
                        <p className="valor"><Dinheiro value={pedido.totalPedido}></Dinheiro></p>
                    </Col>
                    <AcoesFormulario titulo={titulo} tamBotao={tamBotao} /* pedido={pedido.pedido} */ /* dispatch={dispatch} */></AcoesFormulario>
                </Row>
        </Folha>

        

        {/* <ImpressaoPedido pedido={pedido}></ImpressaoPedido> */}

    </>;
    
};


export {FormularioPedido}